window.portalModule.factory 'LogoutService', (Restangular, AuthService) ->

  restAngular = Restangular.withConfig (Configurer) ->
    Configurer.setBaseUrl(AuthService.getConfigData().PHR_AUTHN_ENDPOINT_URL_V3)

  _logoutService = restAngular.all("jwts/invalidate")

  logout: ->
    return _logoutService.post()
